import { LibraryBig } from "lucide-react";

export function Logo({ dark = false }) {
  return (
    <div className={`brand ${dark ? "brand-dark" : ""}`} data-testid="brand-logo">
      <span className="brand-mark">
        <LibraryBig size={19} />
      </span>
      <span>
        Library<span className="brand-accent">OS</span>
      </span>
    </div>
  );
}

export function Loading({ label = "Loading workspace…" }) {
  return (
    <div className="loading-screen">
      <div className="loading-mark">
        <LibraryBig size={24} />
      </div>
      <span>{label}</span>
    </div>
  );
}

export function PageHeader({ eyebrow, title, description, action }) {
  return (
    <div className="page-heading" data-testid="page-heading">
      <div>
        <p className="hero-label">{eyebrow}</p>
        <h1>{title}</h1>
        <p>{description}</p>
      </div>
      {action}
    </div>
  );
}

export function StatCard({ label, value, detail, tone = "blue", icon = null }) {
  return (
    <div className="stat-card" data-testid={`stat-${label.toLowerCase().replace(/\s+/g, "-")}`}>
      <div className={`stat-icon ${tone}`}>{icon}</div>
      <span>{label}</span>
      <strong>{value}</strong>
      <small>{detail}</small>
    </div>
  );
}

export function EmptyState({ icon, title, hint, testId = "empty-state" }) {
  return (
    <div className="empty-state" data-testid={testId}>
      {icon}
      <strong>{title}</strong>
      <span>{hint}</span>
    </div>
  );
}

export function StatusPill({ status }) {
  const value = (status || "").toUpperCase();
  const tone =
    value === "PAID" || value === "ACTIVE" || value === "AVAILABLE" || value === "RETURNED" || value === "PRESENT"
      ? "success"
      : value === "OVERDUE" || value === "EXPIRED" || value === "BLOCKED" || value === "ABSENT" || value === "LOST"
      ? "danger"
      : value === "PENDING" || value === "UPCOMING" || value === "PARTIAL" || value === "LATE" || value === "RESERVED" || value === "MAINTENANCE" || value === "DAMAGED"
      ? "warn"
      : value === "OCCUPIED" || value === "ISSUED"
      ? "info"
      : "neutral";
  return <span className={`status-pill ${tone}`}>{value || "—"}</span>;
}
